import { isRequiredSatisfied } from '../_shared/domain/validation';
import { answersForWidget } from '../_shared/answers-adapter';
import { syncAnswers } from '../../utils/lib/answer-sync';

(function ($) {
  // The Popup jQuery widget
  // see http://jqueryui.com/docs/Developer_Guide
  var Popup = {
    options: {
      hidden: true,
      // Set by the parent question when an answer submits the page at once
      autoadvance: false,
    },

    _create: function () {
      this.options.root = this.element;
      var el = this.element;
      var required = this.element.data('required');
      var soft_required_prompts = 0;
      var trigger = this.trigger();
      var handler = $.proxy(this, '_onTriggerElementClick');
      $(trigger).on('click.yg_popup', handler);
      // Event listener for Bootstrap modal's 'hide.bs.modal' event when dismissing the popup
      // Special validation handling for 'required' option
      var that = this;
      this.element.on('hide.bs.modal.yg_popup', function (event) {
        // This can run before answer sync's delegated `change` listener (a
        // `click` or `change` here closes the modal synchronously), so push
        // the popup's inputs into the store before the rule reads it.
        syncAnswers(el.find('.response-input'));
        if (!that._isAnswerRequirementMet(required, soft_required_prompts)) {
          // Required and unanswered: do not dismiss the modal / popup
          event.preventDefault();
          soft_required_prompts++;

          var response_list_el = el.find('.question-response-list'),
            error = response_list_el.find('.alert-danger');

          if (error.length > 0) {
            error.text(el.data('required-text'));
          } else {
            response_list_el.prepend(
              '<div class="alert alert-danger">' +
                el.data('required-text') +
                '</div>'
            );
          }
        } else if (
          required === 'HARD' ||
          (required === 'SOFT' && soft_required_prompts == 0)
        ) {
          // clear existing validation message. This repeats the legacy gate on
          // purpose: it decides only when the message is removed (screen
          // state), and keeps a SOFT popup answered after its prompt as before.
          // The rule above decides whether the popup may close.
          el.find('.alert-danger').remove();
        }
        that.hidden(true);
      });
    },

    /*
     * The domain required rule over this popup's answer in the store.
     * Popup gets only `data-required`, so SOFT maps onto the domain's
     * `soft_required` here, and the prompt shows once per popup instance.
     * The popup's radios share one variable, so one answer is the whole
     * requirement (`visibleCount: 1`).
     */
    _isAnswerRequirementMet: function (required, soft_required_prompts) {
      var inputs = this.element.find('.response-input');
      var question = {
        required: required,
        soft_required: required === 'SOFT',
        input_id: inputs.attr('name'),
      };
      return isRequiredSatisfied(question, answersForWidget(question), {
        softPromptsShown: soft_required_prompts > 0,
        visibleCount: 1,
      });
    },

    _destroy: function () {
      this.trigger().off('.yg_popup');
      this.element.off('.yg_popup');
      this.element.find('.response-input').off('.yg_popup');
    },

    // set the widget hidden status
    hidden: function (hidden) {
      this.options.hidden = hidden;
    },

    _onTriggerElementClick: function (event) {
      this.toggle();
      event.stopPropagation();
    },

    // toggles the hide/show of the widget
    toggle: function () {
      var is_hidden = this.options.hidden;
      if (is_hidden) {
        if (this._before_popup(this)) {
          this.show();
        }
      } else {
        this.hide();
      }
    },

    show: function () {
      // first, show the overlay, preventing the user from
      //  navigating forward or back (or triggering other answers)
      //  while the popup is being rendered slowly.
      this._show_modal();
      this.element.show('fast', $.proxy(this, '_afterShow'));
    },

    _afterShow: function () {
      this._listen_changes();
      this.hidden(false);
    },

    _listen_changes: function () {
      var self = this;
      this.element
        .find('.response-input')
        .off('change.yg_popup')
        .on('change.yg_popup', function () {
          self._hide_modal();
        });
      if (this.options.autoadvance) {
        // `click` reaches the popup input before the parent question's
        // autoadvance handler, and also fires when an already selected
        // answer is clicked again (which fires no `change`)
        this.element
          .find('.response-input')
          .off('click.yg_popup')
          .on('click.yg_popup', function () {
            self._hide_modal();
          });
      }
    },

    hide: function () {
      this.element.hide('fast', $.proxy(this, '_afterHide'));
    },

    _afterHide: function () {
      this._hide_modal();
      this.hidden(true);
    },

    /*
     * This verifies the trigger input is selected before popping
     * up the popup
     */
    _before_popup: function () {
      var trigger = this.trigger();
      return trigger.is(':checked');
    },

    _show_modal: function () {
      this.element.modal('show');
    },

    _hide_modal: function () {
      if (!this.options.autoadvance) {
        this.element.modal('hide');
        return;
      }
      this.element.removeClass('fade').modal('hide').addClass('fade');
    },

    /*
     * Returns the trigger in order to help perform look ups on
     * dependent widget inputs
     */
    trigger: function () {
      return this.element.closest('.w-choice-base').find('input.top-level');
    },
  };

  $.widget('yougov.yg_popup', Popup);
})(jQuery);
